if (!customElements.get('media-swiper')) {
    customElements.define(
        'media-swiper',
        class extends HTMLElement {
            // Autoplay timer
            timer;
            pastTime = 0;
            slideTime = 0;
            /**
             * @type {'playing' | 'paused' | 'restart' }
             */
            buttonStatus = 'paused';
            constructor() {
                super();
                this.swiperPrev = null;
                this.swiperNext = null;
                this.swiperPagination = null;
                this.swiperContainer = null;
                this.slideshowSwiper = null;

                this.autoplay = this.getAttribute('data-swiper-auto') === 'true';
                this.loop = this.getAttribute('data-loop') === 'true';
                this.swiperNumber = Number(this.getAttribute('data-swiper-num'));
                this.speed = Number(this.getAttribute('data-swiper-delay'));
                this.slideTime = this.speed;
                this.enableSwiper = this.getAttribute('data-enabel-swiper') === 'true';
            }
            connectedCallback() {
                this.swiperContainer = this.querySelector('.swiper-container');

                setTimeout(() => {
                    this.createSwiper();
                    if (this.autoplay) {
                        this.startAutoplay();
                    }
                }, 0)
            }

            createSwiper() {
                if (!this.enableSwiper) return;
                if (this.timer) clearInterval(this.timer);
                this.pastTime = 0;
                this.mySwiper = new Swiper(this.swiperContainer, {
                    slidesPerView: this.swiperNumber,
                    spaceBetween: 0,
                    loop: this.loop,
                    autoplay: false,
                    observer: true,
                    observeParents: true,
                    navigation: {
                        prevEl: this.querySelector('.product-swiper-button-pre'),
                        nextEl: this.querySelector('.product-swiper-button-next'),
                    },
                    pagination: {
                        el: this.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                    on: {
                        // slideChange: function () { },
                        slideChangeTransitionStart: () => {
                            if (this.autoplay) {
                                this.pauseTimer();
                                this.pastTime = 0;
                            }
                        },
                        slideChangeTransitionEnd: () => {
                            if (this.autoplay && this.buttonStatus == 'playing') {
                                // Continue
                                this.resumeTimer();
                            } else if (this.buttonStatus == 'restart' && !this.mySwiper.isEnd) {
                                // When sliding away from the last slide
                                this.setButton('paused');
                            }
                        },
                    },
                });
            }

            setButton(buttonStatus) {
                this.buttonStatus = buttonStatus;
                this.setAttribute('data-button-status', buttonStatus);
            }

            startAutoplay() {
                this.setButton('playing');
                this.resumeTimer();
            }

            restartAutoplay() {
                this.mySwiper.slideTo(0);
                this.setButton('restart');
                this.pastTime = 0;
                this.resumeTimer();
            }

            pauseAutoplay() {
                this.setButton('paused');
                this.pauseTimer();
            }

            // restartAutoplay() {
            //   this.setButton('restart');
            //   this.restartTimer();
            // }

            resumeTimer() {
                if (this.timer) clearInterval(this.timer);
                this.classList.remove('progress-paused');
                this.timer = setInterval(() => {
                    this.pastTime += 20;
                    if (this.pastTime >= this.slideTime) {
                        this.pastTime = 0;
                        // handle next slide
                        if (this.mySwiper && this.mySwiper.isEnd) {
                            // Ended
                            this.restartAutoplay();
                        } else {
                            // Continue
                            this.mySwiper && this.mySwiper.slideNext();
                        }
                    }
                }, 20);
            }

            pauseTimer() {
                if (this.timer) clearInterval(this.timer);
                this.classList.add('progress-paused');
            }

            restartTimer() {
                this.pauseTimer();
                this.pastTime = 0;
            }

            destroySwiper() {
                this.mySwiper.destroy(false);
            }
        }
    );
}

